/**
 * Gate contextual prompt chips on preference hydration.
 * After preferences load, only an explicit `false` opts out; unset values remain
 * eligible for rollout auto-enable.
 */
export const isAiContextualPromptChipsPreferenceEnabled = (
  preferencesLoaded: boolean,
  preferenceValue: boolean | undefined,
): boolean => {
  if (!preferencesLoaded) {
    return false;
  }

  return preferenceValue !== false;
};
